import { createContext } from 'react'
import { AccountSearchState } from '../../../types'

export const INITIAL_ACCOUNT_SEARCH_STATE: AccountSearchState = {
  accountResults: [],
  loadingResults: false,
  errorMessage: undefined,
  searchTerm: '',
}

export interface AccountSearchProps {
  accountSearchState: AccountSearchState
  searchAccounts: (searchTerm: string) => void
}

export const AccountSearchContext = createContext<AccountSearchProps>({
  accountSearchState: INITIAL_ACCOUNT_SEARCH_STATE,
  searchAccounts: () => {},
})
